export default __webpack_public_path__ + "static/media/cs.ef7d0a34.png";